// Taalkiezer (#86): de <details> in de kop werkt zonder dit script; dit sluit hem bij
// Escape (focus terug op de knop) en bij een klik ernaast, zoals de zoeklade.

const taal = document.querySelector('.taal');
if (taal) {
  const knop = taal.querySelector('summary');
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && taal.open) { taal.open = false; knop.focus(); }
  });
  document.addEventListener('click', (e) => { if (taal.open && !taal.contains(e.target)) taal.open = false; });
}
